module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui-container",
    class: {
      'ui-container_cursor': _vm.cursor, 'ui-container_top': _vm.noTopMargin
    },
    on: {
      "click": function($event) {
        return _vm.$emit('select', $event)
      }
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-117efc0e","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/blocks/form/components/select/components/container/Container.vue
// module id = a5ffc14e9c5926998132
// module chunks = 89